// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";
const AnimatedText11 = () => {
    const { ref, inView } = useInView({
        triggerOnce: true, // animate only once when it first comes into view
        threshold: 0.1,    // trigger when 10% of the component is in view
      });
  return (
    <div ref={ref} className={`container ${inView ? "animate" : ""}`}>
      <div className="text a"> Frequently </div>
      <div className="text b"> asked </div>
      <div className="text c"> questions  </div>
    </div>
  );
};
export default AnimatedText11;